<template>
    <div>
        <v-form ref="form">
            <v-row no-gutters>
                <v-col cols="12">
                    <v-row>
                        <v-col cols="12" class="py-0">
                            <switch-button
                                :value="emailServiceEnabled"
                                :label="$t('Email service (custom domain)')"
                                @change="handleInput('emailServiceEnabled', $event ? 1 : 0)"
                            />
                        </v-col>
                        <v-col cols="12">
                            <v-row
                                v-if="emailServiceEnabled"
                                no-gutters
                                class="align-center"
                            >
                                <v-col
                                    cols="6"
                                >
                                    <v-select
                                        :value="selectedEmailIntegrationId"
                                        :items="emailAutomationEmails"
                                        item-text="email"
                                        item-value="id"
                                        :label="$t('Select e-mail account')"
                                        outlined
                                        @input="handleInput('vendor', {email_integration_id: $event})"
                                    />
                                </v-col>
                                <v-col class="ml-2">
                                    <icon-button icon="CirclePlus" color="primary" icon-size="20" @click="openEmailsOverview"></icon-button>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-form>
        <Dialog
            v-if="showDialog"
            :value="true"
            :header-text="$t('Company email address')"
            persistent
            actions-right-align
            full-content-width
            :width="850"
            @close_modal="handleCloseDialog"
        >
            <v-row no-gutters>
                <EmailingConnectionsOverview />
            </v-row>
            <template #footer>
                <primary-button @click="handleCloseDialog">{{ $t('Close') }}</primary-button>
            </template>
        </Dialog>
    </div>
</template>


<script>
import AppModule from "@/store/modules/app"
import ApiEmailIntegration from "@/api/email_automation/email_integration"
import appStoreDialog from "@/store/modules/AppStoreDialog/appStoreDialog";
import OutlineButton from "@/components/Buttons/OutlineButton";
import {ref, onMounted} from "@vue/composition-api";
import EmailingConnectionsOverview from './EmailingConnectionsOverview.vue'
import Dialog from '../Dialog.vue'

export default {
    name: "BillingDialogEmailSettingsInputs",
    components: {
        EmailingConnectionsOverview,
        OutlineButton,
        Dialog
    },
    props: {
        emailServiceEnabled: {
            type: Number,
            default: 0
        },
        selectedEmailIntegrationId: {
            type: Number,
            required: false,
            default: null
        }
    },
    setup(props, ctx) {
        const emailAutomationEmails = ref([])
        const {appStoreDialogGetters} = appStoreDialog()
        const showDialog = ref(false)
        const { info_email } = AppModule()

        const handleInput = function (name, value) {
            ctx.emit(`update:${name}`, value)
        }

        const openEmailsOverview = () => {
            showDialog.value = true
        }

        const getEmailIntegrations = async () => {
            emailAutomationEmails.value = (await ApiEmailIntegration.getEmailIntegrations(
                appStoreDialogGetters.getSelectedCompany().id
            )).email_automation_emails
            emailAutomationEmails.value = [{id: null, email: info_email.value}, ...emailAutomationEmails.value]
        }

        onMounted(async () => {
            await getEmailIntegrations()
        })

        const handleCloseDialog = async () => {
            showDialog.value = false
            await getEmailIntegrations()
            const stillExists = emailAutomationEmails.value.find((x) => x.id === props.selectedEmailIntegrationId)
            if(!stillExists) handleInput('vendor', {email_integration_id: null})
        }

        return {
            handleInput,
            emailAutomationEmails,
            openEmailsOverview,
            showDialog,
            handleCloseDialog
        };
    }
};
</script>
